import { render, staticRenderFns } from "./UnauthorizedUserPopup.vue?vue&type=template&id=915edae2&scoped=true"
import script from "./UnauthorizedUserPopup.vue?vue&type=script&lang=js"
export * from "./UnauthorizedUserPopup.vue?vue&type=script&lang=js"
import style0 from "./UnauthorizedUserPopup.vue?vue&type=style&index=0&id=915edae2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915edae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('915edae2')) {
      api.createRecord('915edae2', component.options)
    } else {
      api.reload('915edae2', component.options)
    }
    module.hot.accept("./UnauthorizedUserPopup.vue?vue&type=template&id=915edae2&scoped=true", function () {
      api.rerender('915edae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/UnauthorizedUserPopup.vue"
export default component.exports